<template>
	<div id="signup" class="auth">
		<h1 class="auth__title text-center">{{ $t('Sign_Up') }}</h1>

		<message v-if="error"
				 :text="error"
				 @closeMessage="closeMessage">
		</message>

		<form class="auth__form">
			<field
					v-for="field in fields"
					v-model="field.value"
					:name="field.name"
					:type="field.type"
					:placeholder="field.placeholder"
					:autofocus="field.autofocus">
			</field>

			<p>* {{ $t('Required_fields') }}</p>

			<button
					class="auth__form__button"
					@click.prevent="onSignUp"
					@keyup.enter="onSignUp">
				{{ $t('Sign_Up') }}


			</button>
		</form>

		<router-link
				:to="{ name: 'login', query: { email: this.fields.email.value }}">
			{{ $t('Have_an_account_q_Log_in') }}


		</router-link>

	</div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex'
    import Vue from 'vue'
    import { localStorageMixin } from '../../mixins'
    import Field from '../../components/Field.vue'
    import Message from '../../components/Message.vue'

    export default {
        name: 'signup',

        mixins: [localStorageMixin],

        components: {
            Field,
            Message
        },

        data: () => ({
            fields: {
                name: {
                    name: Vue.i18n.translate('Name') + ' *',
                    value: '',
                    type: 'text',
                    placeholder: Vue.i18n.translate('Name'),
                    autofocus: true
                },
                surnames: {
                    name: Vue.i18n.translate('Surnames') + ' *',
                    value: '',
                    type: 'text',
                    placeholder: Vue.i18n.translate('Surnames'),
                    autofocus: false
                },
                company: {
                    name: Vue.i18n.translate('Company_or_business_name'),
                    value: '',
                    type: 'text',
                    placeholder: Vue.i18n.translate('Company_or_business_name'),
                    autofocus: false
                },
                email: {
                    name: Vue.i18n.translate('Email_Address') + ' *',
                    value: '',
                    type: 'text',
                    placeholder: 'email@email.com',
                    autofocus: true
                },
                password: {
                    name: Vue.i18n.translate('Password'),
                    value: '',
                    type: 'password',
                    placeholder: Vue.i18n.translate('Password') + ' *',
                    autofocus: false
                },
                confirm: {
                    name: Vue.i18n.translate('Confirm_Password') + ' *',
                    value: '',
                    type: 'password',
                    placeholder: Vue.i18n.translate('Password'),
                    autofocus: false
                },
            },
            error: null
        }),

        created () {
            if (this.$route.query.email) {
                this.fields.email.value = this.$route.query.email
            }
        },

        computed: {
            ...mapGetters(['user'])
        },

        methods: {
            ...mapActions([
                'SIGN_UP_USER',
                'INIT_NOTES',
                'UPDATE_USER_INITIAL_DATA'
            ]),

            onSignUp () {
                if (this.fields.password.value != this.fields.confirm.value) {
                    this.error = Vue.i18n.translate('The_passwords_do_not_match') + '.'
                    return
                }

                if (this.fields.email.value === null & this.fields.password.value === null) {
                    this.error = Vue.i18n.translate('Please_enter_an_email_address') + '.'
                    return
                }

                const data = {
                    name: this.fields.name.value,
                    surnames: this.fields.surnames.value,
                    company: this.fields.company.value,
                    email: this.fields.email.value,
                    password: this.fields.password.value
                }

                const user_initial_data = {
                    name: this.fields.name.value,
                    surnames: this.fields.surnames.value,
                    company: this.fields.company.value
                }

                this.SIGN_UP_USER(data)
                    .then(() => {
                        this.ls_pushUser(this.user)
                        this.UPDATE_USER_INITIAL_DATA(user_initial_data)
                        this.INIT_NOTES()
                            .then(() => this.$router.push({name: 'app'}))
                            .catch((error) => this.error = error.message)
                    })
                    .catch((error) => {
                        this.error = error.message
                    })
            },

            closeMessage () {
                this.error = null
            }
        },

        head: {
            title: {
                inner: 'Sign Up'
            }
        }

    }
</script>




// WEBPACK FOOTER //
// SignUp.vue?0b46d60a